import React, { FC, memo } from 'react';
import { UseSimpleStore, useSimpleStoreList } from '@om-fe/store';
import { MixedGroupedTournamentModel } from '../mixed-grouped/mixed-grouped.types';
import { Slider } from '@om-fe/widgets/dist/components/slider/slider';
import { BemModifiersMap } from '@om-fe/core/core/types';
import { TournamentNavItem } from '../tournament-nav/tournament-nav-item';
import { navBem } from '@om-fe/widgets/dist/components/nav/nav.utils';
import { TournamentParams } from '@om-fe/models';

export interface MixedGroupedMatchListProps {
    readonly useStore: UseSimpleStore<MixedGroupedTournamentModel>;
    readonly hasAllButton?: boolean;
    readonly hasOutrightsButton?: boolean;
    readonly activeTab?: string;
    readonly hasArrows?: boolean;
    readonly handleTournamentParams?: (params: TournamentParams) => void;
    readonly tournamentParams: TournamentParams;
    readonly navLayout?: boolean;
}

export const TournamentNav: FC<MixedGroupedMatchListProps> = memo((
    {
        useStore,
        hasAllButton = false,
        hasOutrightsButton = false,
        activeTab,
        hasArrows,
        handleTournamentParams,
        tournamentParams,
        navLayout,
    }: MixedGroupedMatchListProps,
) => {
    const list: string[] = useSimpleStoreList(useStore);
    const tournamentList: React.ReactNode[] = [];

    if (hasAllButton && list.length) {
        tournamentList.push(
            <TournamentNavItem
                useStore={useStore}
                id={'all'}
                activeTab={activeTab}
                handleTournamentParams={handleTournamentParams}
                tournamentParams={tournamentParams}
                extraClassName={`TournamentId--all`}
            />
        )
    }

    if (hasOutrightsButton) {
        tournamentList.push(
            <TournamentNavItem
                useStore={useStore}
                id={'outrights'}
                activeTab={activeTab}
                handleTournamentParams={handleTournamentParams}
                tournamentParams={tournamentParams}
                extraClassName={`TournamentId--outrights`}
            />
        )
    }
    
    if (list.length > 0) {
        list.map((id: string) => (
            tournamentList.push(
                <TournamentNavItem
                    useStore={useStore}
                    id={id}
                    activeTab={activeTab}
                    handleTournamentParams={handleTournamentParams}
                    tournamentParams={tournamentParams}
                    extraClassName={`TournamentId--${id}`}
                />
            )
        ));
    }

    const modifiers: BemModifiersMap = {
        TournamentNav: !navLayout,
        TournamentNavOnSport: !!navLayout,
        ItemToStartUnequalWidth: true,
        Small10: true,
        Tertiary: true,
    };

    return (
        <div className={navBem()}>
            <Slider
                sliderItems={tournamentList}
                modifiersFromParent={modifiers}
                hasArrows={hasArrows && list.length > 0}
            />
        </div>
    );
});